/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import Tabs from './modules/tabs'
_('tab-trigger').nodes().map((el) => new Tabs(el))

----------------------------------------------------------------------------
Attributes:
----------------------------------------------------------------------------
data-element="tabs"             - overall container
data-behaviour="tab-trigger"    - individual tab items to trigger change
data-element="tab-button"       - optional button on mobile to hide and show tabs
*/

import { _, removeClasses, makeGtmCall } from '../utils.js'

class Tabs {
    constructor(el) {
        this.el = el
        this.tabsContainer = this.el.closest(_('tabs', 'element').str())
        this.activeTabClass = this.el.dataset.class

        this.activeTabContentClass = _('tab-container', 'element').nodeFrom(
            this.tabsContainer,
        ).dataset.class

        this.allTabTriggers = _('tab-trigger').nodesFrom(this.tabsContainer)
        this.allTabContainers = _('tab-container', 'element').nodesFrom(
            this.tabsContainer,
        )

        this.tabButton = _('tab-button', 'element').nodeFrom(this.tabsContainer)
        window.addEventListener('hashchange', this.triggerFromHash)
        this.el.addEventListener('click', this.changeHash)
        this.triggerFromHash()
    }
    /**
     * @param  {object} el
     */

    changeHash = (e) => {
        e.preventDefault()
        const hash = e.currentTarget.getAttribute('href') || ''
        if (this.tabButton) {
            this.tabButton.innerHTML = e.currentTarget.innerHTML
        }
        history.pushState(null, null, `${hash}`)
        this.triggerFromHash()
    }

    triggerFromHash = () => {
        const allTabs = _('tab-trigger').nodes()

        if (window.location.hash === '' || !allTabs.length) {
            return false
        }

        let activatedTab = null
        allTabs.forEach((el) => {
            if (el.getAttribute('href') === window.location.hash) {
                this.toggleTabs(el)
                activatedTab = el
            }
        })

        if (activatedTab) {
            const parent =
                activatedTab.closest(_('tabs', 'element').str()) ||
                activatedTab.parentElement
            if (parent) {
                const header = document.querySelector('.header')
                const headerHeight = header ? header.offsetHeight : 0
                const parentTop = parent.getBoundingClientRect().top + window.pageYOffset - 75
                const targetTop = Math.max(0, parentTop - headerHeight)
                window.scrollTo({ top: targetTop, behavior: 'smooth' })
            }
        }
    }

    /**
     * @param  {object} el
     */

    toggleTabs = (el) => {
        const currentTab = el
        if (this.tabButton) {
            this.tabButton.innerHTML = el.innerHTML
        }
        const isTabOpen = currentTab.classList.contains(this.activeTabClass)
        if (isTabOpen) {
            return false
        }
        const tabTarget = currentTab.getAttribute('href')

        currentTab.dataset.gtmEvent = 'tab-open'
        currentTab.dataset.gtmName = tabTarget
        makeGtmCall(el)
        removeClasses(this.allTabTriggers, this.activeTabClass)
        removeClasses(this.allTabContainers, this.activeTabContentClass)
        currentTab.classList.add(this.activeTabClass)

        const tabContent = document.querySelector(tabTarget)
        if (tabContent) {
            tabContent.classList.add(this.activeTabContentClass)
        }
    }
}

export default Tabs
